import React from 'react';
import { createRoot } from 'react-dom/client';
import '@/locales/i18n';
import '@/dayjs';

import { reportWebVitals } from '@/report-web-vitals';
import { initSentry } from '@/lib/sentry';
import { registerChunkRecovery, swallowStaleChunkError } from '@/lib/chunkRecovery';
import App from '@/App';
import '@/index.css';

registerChunkRecovery();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

void initSentry().catch(swallowStaleChunkError);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
